export default "__VITE_ASSET__CwWkA3KL__"